import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./slices/AppSlice";
import earnReducer from "./slices/EarnSlice";
import messagesReducer from "./slices/MessagesSlice";
import pendingTransactionsReducer from "./slices/PendingTxnsSlice";
import rewardsReducer from "./slices/RewardsSlice";
import multicall from "src/lib/state/multicall";
import httpReducer from "src/state/http/reducer";
// reducers are named automatically based on the name field in the slice
// exported in slice files by default as nameOfSlice.reducer

const store = configureStore({
  reducer: {
    //   we'll have state.account, state.bonding, etc, each handled by the corresponding
    // reducer imported from the slice file
    pendingTransactions: pendingTransactionsReducer,
    messages: messagesReducer,
    app: appReducer,
    reward: rewardsReducer,
    earn: earnReducer,
    multicall: multicall.reducer,
    http: httpReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
